import React, { useState } from "react";
import {
  IconChevronRight,
  IconPaperclip,
  IconCaretDownFilled,
} from "@tabler/icons-react";

const ContactHome = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("Select service");

  const handleSelect = (service) => {
    setSelectedService(service);
    setIsOpen(false);
  };
  return (
    <div>
      <section className=" bg-gray-100 py-12 md:py-20">
        <div className="container pt-2 mb-5">
          {/* Header Section */}
          <div className="mx-auto mb-5 max-w-[921px] text-center lg:mb-[60px]"  data-aos="fade-right">
            <h5 className="h5 mb-3 font-semibold text-[#006DB2] tracking-wide">
              Got a Question?
            </h5>
            <h3 className="h3 mb-3 text-4xl font-bold text-gray-800 leading-tight">
              We Are Here to Answer It!
            </h3>
            <p className="text-gray-600 text-lg">
              Please send us information about your project. One of our project
              managers will evaluate your requirements and provide a formal
              proposal. Detailed information helps us assess your project
              accurately.
            </p>
          </div>

          <div className="grid grid-cols-12 items-center gap-6" data-aos="fade-down">
            {/* Form Section */}
            <div className="col-span-12 lg:col-span-6" data-aos="fade-right">
              <form
                className="rounded-2xl px-5 py-6 sm:px-3 md:py-8"
                style={{ backgroundColor: "#42a3b3b8" }}
              >
                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="text"
                      placeholder="Name*"
                       className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="number"
                      placeholder="Phone*"
                       className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  <div className="col-span-2 md:col-span-1">
                    <input
                      type="email"
                      placeholder="Email*"
                        className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                      required
                    />
                  </div>
                  {/* <div className="col-span-2 md:col-span-1">
                    <input
                      type="text"
                      placeholder="Company Name"
                      className="bg-white w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                    />
                  </div> */}
                  <div className="relative col-span-2">
                    <div className="relative">
                      <div className="select-container relative" data-select>
                        <div
                          className="select-toggle flex w-full cursor-pointer select-none items-center justify-between rounded-[30px] border border-white bg-white px-4 py-2 text-start focus:!border-gray focus:outline-none md:px-6"
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <span className="select-text text-black">
                            {selectedService}
                          </span>
                          <span className="text-title">
                            <IconCaretDownFilled
                              className={`transition-transform ${
                                isOpen ? "rotate-180" : ""
                              }`}
                            />
                          </span>
                        </div>
                        {isOpen && (
                          <ul className="select-services absolute left-0 top-full z-20 w-full flex-col overflow-hidden rounded-xl bg-white shadow-2xl">
                            {["Need Web Application", "Need Mobile App", "Want to learn any Technology"].map(
                              (service) => (
                                <li
                                  key={service}
                                  className="cursor-pointer border-b border-n6 px-4 py-2 text-title duration-300 hover:bg-primary hover:text-n8 md:py-2"
                                  onClick={() => handleSelect(service)}
                                >
                                  {service}
                                </li>
                              )
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="relative col-span-2">
                    <label
                      htmlFor="attachment"
                      className="text-black bg-white flex w-full appearance-none items-center justify-between rounded-[30px] border border-n5 px-6 py-2 text-n4 focus:outline-none"
                    >
                      Add An Attachment
                      <input
                        type="file"
                        id="attachment"
                        className="hidden"
                        name="attachment"
                      />
                      <IconPaperclip size={20} />
                    </label>
                  </div>
                  <div className="col-span-2">
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Let us know what you need"
                      rows="3"
                      className="bg-white text-black w-full rounded-[30px] border border-n5 px-6 py-2 text-n8 focus:border-n7 focus:outline-none"
                    ></textarea>
                  </div>
                  <div className="relative col-span-2 text-n8">
                    <div className="mb-3 flex items-center gap-3 text-black">
                      <input
                        type="checkbox"
                        id="update"
                        className="scale-125 accent-n8"
                        name="update"
                      />
                      <label htmlFor="update">
                        I would like to be updated on the latest products, event
                        announcements, and thought leadership.
                      </label>
                    </div>
                    <div className="text-black flex items-center gap-3">
                      <input
                        type="checkbox"
                        id="privacy"
                        className="scale-125 accent-n8"
                        name="privacy"
                      />
                      <label htmlFor="privacy">
                        I have read and accepted the Terms & Conditions Privacy
                        Policy
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 mt-3 flex justify-center md:mt-5">
                    <button className="btn border-white px-10 bg-white text-black">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Contact Links with Animation */}

            <div className="col-span-12 lg:col-span-6 " data-aos="fade-left">
              <ul className="space-y-4">
                <li className="mb-3">
                  <a
                    className=" list-item group flex items-center justify-between  transition-all duration-300 p-4 rounded-lg"
                    href="/contact"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Book a Demo</h4>
                      <p className="text-para">
                        with our engagement specialist
                      </p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className="list-item group flex items-center justify-between transition-all duration-300 p-4 rounded-lg"
                  href="/contact"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Send Your CV</h4>
                      <p className="text-para">if you want to join your team</p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className="list-item group flex items-center justify-between  transition-all duration-300 p-4 rounded-lg"
                    href="mailto:hr@cognityinfo.com"
                  >
                    <div>
                      <h4 className="h4 mb-2 text-title">Reach Us via Email</h4>
                      <p className="text-primary">hr@cognityinfo.com</p>
                    </div>
                    <span
                      className="arrow-icon flex-shrink-0 text-white"
                      style={{ backgroundColor: "#42a3b3b8" }}
                    >
                      <IconChevronRight size={24} />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactHome;
